define('views/modules/calendar/animated-session/animation/rename/form/animation-rename-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/calendar/session/renamed-animation',
    // services
    'services/i18n',
    // views
    'views/parts/form/textbox',
    'views/parts/form/textarea',
    'src/views/form-view',
    'views/parts/alert/alert-list',
    // templates
    'text!templates/modules/calendar/animated-session/animation/rename/form/animation-rename-form.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MRenamedAnimation,
    //services
    i18n,
    // views
    VTextbox,
    VTextarea,
    VForm,
    VAlertList,
    // templates
    TAnimationRenameForm
) {

    var VAnimationRenameForm = VForm.extend({
        template: TAnimationRenameForm,

        // abstracting selectors out of the view logic
        regions: {
            root: '#custom-name-form',
            name: ".name-input",
            alert: ".alert-list",
            description: ".description-input",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = this.options.group;

            var model = this.model;
            if (!model) {
                model = this.model = new MRenamedAnimation();
                this.initModel();
            }

            var view = this.view = {
                name: new VTextbox({ label: 'Name', attribute: 'name', labelposition: 'outer', model: model }),
                description: new VTextarea({ label: 'Description', attribute: 'description', labelposition: 'outer', model: model, rows: 2, }),
                alert: new VAlertList({ collection: new Backbone.Collection([]) })
            };


            this.listenTo(model, 'change', this.onModelChange);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            // Assign Views
            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.name, zone.$name)
                .assign(view.description, zone.$description)
                .assign(view.alert, zone.$alert);

            this.view.alert.reset();
            this.setPristine();

            return this;
        },

        resetWithAnimation: function(animation) {
            this.animation = animation;
            this.modelMaster.resetWithAnimation(animation);
            this.view.name.setValue(animation.get('name'));
            this.view.description.setValue(animation.get('description'));
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.modelMaster.reset(attrs);
            return this;
        },


        onError: function(response) {
          //EXERCISE_RENAME_ACCESS_DENIED
          if (response && response.responseJSON) {
            var errorCode = response.responseJSON.code,
                message = response.responseJSON.message;

            if (errorCode) {
              this.view.alert.reset();
              this.view.alert.addError("api-messages:" + errorCode.replace(/_/g, '-'));
            }
          }
        },

        onSubmit: function() {
            if (_.isEmpty(this.view.name.getValue())) {
                this.view.alert.reset();
                this.view.alert.addError(i18n.t("messages:message-exercise-rename-required-fields"));
                return false; //cancel submit
            } else {
                var model = this.model;
                if (model.isNew()) {
                    model.set({
                        group: this.group._id,
                    });
                }
            }
        },

        onModelChange: function() {
            this.trigger('model:change', this.isDirty());
        },

    });

    return VAnimationRenameForm;

});

